// A filter change waiting out the filter watcher's debounce. Redux's
// isFiltering only goes up once the run starts, so without this anything that
// reads the current filter id in that window reads the filter being replaced.
//
// Keyed by entity kind because wells and facilities each have a watcher, and a
// shared slot would let one entity's run clear the other's pending change.
import { create } from "zustand";

import { EntityKind } from "models/entityKind";

export interface FilterScheduledStore {
  scheduled: Record<EntityKind, boolean>;
  setFilterScheduled: (entityKind: EntityKind, scheduled: boolean) => void;
  reset: () => void;
}

const initialState: Pick<FilterScheduledStore, "scheduled"> = {
  scheduled: { [EntityKind.Well]: false, [EntityKind.Facility]: false }
};

export const useFilterScheduledStore = create<FilterScheduledStore>()((set, get) => ({
  ...initialState,
  setFilterScheduled: (entityKind, scheduled) => {
    if (get().scheduled[entityKind] === scheduled) {
      return;
    }
    set({ scheduled: { ...get().scheduled, [entityKind]: scheduled } });
  },
  reset: () => set({ scheduled: { ...initialState.scheduled } })
}));

export const selectFilterScheduled =
  (entityKind: EntityKind) =>
  (s: FilterScheduledStore): boolean =>
    s.scheduled[entityKind];
